<template>
  <Layout>
    <!-- <video
      src="@assets/videos/bg-login-compress.mp4"
      autoplay
      loop
      playsinline
      muted
    ></video> -->
    <!-- end row -->
    <div class="account-pages my-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-5">
            <div class="card bg-transparent-50">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-md-12 p-5">
                    <div class="mx-auto mb-5 text-center">
                      <a routerLink="/">
                        <img
                          src="@assets/images/logo-white.png"
                          alt
                          height="54"
                        />
                        <!--												<h3 class="d-inline align-middle ml-1 text-logo text-white"
													>SMART</h3
												>-->
                      </a>
                    </div>

                    <h6 class="h5 mb-0 mt-4 text-white">Welcome back!</h6>
                    <p class="text-white mt-1 mb-4">
                      Enter your username and password to access admin panel.
                    </p>

                    <b-alert
                      v-model="isAuthError"
                      variant="danger"
                      dismissible
                      >{{ authError }}</b-alert
                    >

                    <b-form
                      class="authentication-form"
                      @submit.prevent="tryToLogIn"
                    >
                      <div class="form-group">
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend bg-white">
                            <span class="input-group-text">
                              <feather
                                type="user"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="input-1"
                            v-model="username"
                            type="text"
                            required
                            placeholder="Enter username"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="form-group mt-4">
                        <label class="form-control-label text-white"
                          >Password</label
                        >
                        <router-link
                          to="forget-password"
                          class="float-right text-unline-dashed ml-1 text-white"
                          >Forgot your password?</router-link
                        >
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend bg-white">
                            <span class="input-group-text">
                              <feather
                                type="lock"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            placeholder="Enter your password"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            id="checkbox-signin"
                            type="checkbox"
                            class="custom-control-input"
                            checked
                          />
                          <!-- <label
                            class="custom-control-label text-white"
                            for="checkbox-signin"
                          >
                            Remember me
                          </label> -->
                        </div>
                      </div>
                      <b-form-group id="button-group" class="mt-4 mb-1">
                        <b-button
                          type="submit"
                          variant="danger"
                          class="btn-block"
                        >
                          <span v-if="!tryingToLogIn">Log In</span>
                          <template v-else>
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Logging in...
                          </template>
                        </b-button>
                      </b-form-group>
                    </b-form>
                    <div class="py-3 text-center">
                      <div class="row mt-3">
                        <div class="col-12 text-center">
                          <p class="text-white-50">
                            Don't have an account?
                            <router-link
                              tag="a"
                              to=""
                              class="text-danger font-weight-bold ml-1"
                            >
                              <b>Contact Your Admin!</b>
                            </router-link>
                            <!-- <a
                              routerLink="/account/signup"
                              class="text-primary font-weight-bold ml-1"
                            >Sign Up</a>-->
                          </p>
                        </div>
                        <!-- end col -->
                      </div>
                      <!-- end row -->
                    </div>
                  </div>
                  <!--									<div class="col-lg-6 d-none d-md-inline-block">
										<div class="auth-page-sidebar">
											<div class="overlay"></div>
											<div class="auth-user-testimonial">
												<p class="font-size-24 font-weight-bold text-white mb-1"
													>Offshore Support Vessel!</p
												>
												<p class="lead"
													>"When the stars come to the sea"</p
												>
												<p>- Triton Global Maritim</p>
											</div>
										</div>
									</div>-->
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/default'
import { authMethods, authComputed } from '@state/helpers'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    }
  },
  computed: {
    ...authComputed,
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            username: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  created() {
    if (this.loggedIn) {
      this.$swal('Logged In', 'You are already logged in.', 'success')
      this.$router.push({ name: 'Dashboard' })
    }
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null

      let res = await this.logIn({
        username: this.username,
        password: this.password,
      })
      let res_prof = await this.getProfile()
      if (res.status == 'success' && res_prof.status == 'success') {
        this.tryingToLogIn = false
        this.isAuthError = false
        // Redirect to the originally requested page, or to the home page
        this.$router.push(
          this.$route.query.redirectFrom || { name: 'Dashboard' }
        )
      } else {
        this.tryingToLogIn = false
        this.authError = res.data.message
          ? res.data.message
          : 'Something wrong with the server. Please try again later.'
        this.isAuthError = true
      }
    },
  },
}
</script>

<style lang="scss" module></style>
